import React, { useEffect } from 'react';
import AppLinkBar from 'primitives/appLinkBar';
import PatternSvg from 'components/svg/patternSvg';
import classnames from 'classnames';
import QuarterSvg from 'components/svg/quarterSvg';
import { ShIntlMessageDefinition, ShText } from '@shoootin/translations';

//@ts-ignore
import { TabsetPros } from 'legacyJs/tabset';

import { LinkData } from '../../appTypes';
import AppImage, {
  AppGatsbyImage,
  AppGatsbyImageFluid,
} from '../../primitives/appImage';
import { isString } from 'lodash';

export type PrestationProType = LinkData & {
  p1: ShIntlMessageDefinition;
  p2: ShIntlMessageDefinition;
};

export type QuarterMode = 'photo' | 'matterport' | 'video' | 'drone';

type PrestationProImage = AppGatsbyImageFluid | string;

const PrestationTabsetPros = ({
  nav,
  quarterMode,
  images,
}: {
  nav: PrestationProType[];
  images: PrestationProImage[];
  quarterMode: QuarterMode;
}) => {
  useEffect(() => {
    new TabsetPros('.tabset-pros');
  }, []);
  return (
    <div className="tabset tabset-pros">
      <AppLinkBar links={nav} modifier="tabset-nav" />
      <div className="tabset-content">
        {nav.map((pro, i) => (
          <PrestationPro
            key={i}
            pro={pro}
            image={images[i]}
            quarterMode={quarterMode}
            classes={classnames('tabset-panel', { active: i === 0 })}
          />
        ))}
      </div>
    </div>
  );
};
const PrestationPro = ({
  pro,
  image,
  classes,
  quarterMode,
}: {
  pro: PrestationProType;
  image: PrestationProImage;
  classes: string;
  quarterMode: QuarterMode;
}) => {
  return (
    <div className={classes}>
      <div className="prestation-pros">
        <div
          className="prestation-pros__caption tabset-caption"
          data-parallax="0.4"
        >
          <p>
            <ShText message={pro.p1} />
          </p>
          <p>
            <ShText message={pro.p2} />
          </p>
          <PatternSvg />
        </div>
        <div className="prestation-pros__figure">
          <div
            className="prestation-pros__image tabset-image"
            data-parallax="0.2"
          >
            {isString(image) ? (
              <AppImage src={image} lazy />
            ) : (
              <AppGatsbyImage
                fluid={image}
                style={{ width: '100%', maxWidth: 450 }}
              />
            )}
          </div>
          <div
            className="prestation-pros__pattern tabset-pattern"
            data-parallax="0.4"
          >
            <PatternSvg />
          </div>
        </div>
        <div
          className="prestation-pros__quarter tabset-graphic"
          data-parallax="0.6"
        >
          <QuarterSvg mode={quarterMode} />
        </div>
      </div>
    </div>
  );
};

export default PrestationTabsetPros;
